<template>
    <div class="photo-upload position-relative">
        <input type="file" name="file" :id="'photoUpload'+offset" class="photo-upload-input position-absolute" @change="uploadFileFunction" accept="image/*">
        <label :for="'photoUpload'+offset">
            <img :src="imageUrl" class="rounded" alt="写真" style="max-width:100%;">
            <div :id="'preview'+offset" class="preview rounded p-2 overflow-hidden"></div>
        </label>
    </div>

    <div class="text-center mt-2">
        <a v-if="deleteUrl" :href="deleteUrl" class="small"><img src="/images/icon_delete.png" width="32" alt="削除" class="align-middle pb-1 pe-2">画像の削除</a>
    </div>
</template>

<script>
import heic2any from "heic2any";
export default {
    props: {
        errors: {
            type: Object,
            default: () => {
                return {}
            }
        },
        old: {
            type: Array,
            default: [""]
        },
        imageUrl: {
            type: String,
            default: null
        },
        deleteUrl: {
            type: String,
            default: null
        },
        offset: {
            type: Number,
            default: 0
        },
        apiUrl: {
            type: String,
            default: null
        },
    },
    mounted() {
        console.log(this.apiUrl)
        // if(this.items.length == 0) {
        //      this.addBlock()
        // } else {
        //     this.blocks = this.items
        // }
    },
    data() {
        return {
            uploadFile: null
        }
    },
    methods: {
        async uploadFileFunction(e) {
            const files = e.target.files || e.dataTransfer.files;
            console.log(files)
            this.uploadFile = files[0];
            if (this.checkExt(files[0].name)) {
                await this.changeHeicImage(e.target.files[0]);
            } else {
                console.log('nonChangeHeicImage')
                await this.postData(e.target.files[0]);
            }
        },

        async changeHeicImage(before_file) {
            console.log("changeHeicImage");
            heic2any({
            blob: before_file,
            toType: "image/png",
            })
            .then(async (resultBlob) => {
                console.log('changeHeicImage')
                this.postData(resultBlob)

            })
            .catch(function (x) {
                console.log(x)
            });
        },
  async postData(file){
    let formData = new FormData();
    formData.append('file', file);
    let config = {
        headers: {
            'content-type': 'multipart/form-data'
        }
    };
    await axios
        .post(this.apiUrl, formData, config)
        .then(function(response) {
            // response 処理
            location.reload()

        })
        .catch(function(error) {
            // error 処理
            console.log(error)
            alert('アップロードエラー')
    })
  },
  checkExt(filename)
  {
    var allow_exts = new Array('heic', 'heif');
    //比較のため小文字にする
    var ext = this.getExt(filename).toLowerCase();
    //許可する拡張子の一覧(allow_exts)から対象の拡張子があるか確認する
    if (allow_exts.indexOf(ext) === -1) return false;
    return true;
  },
  //ファイル名から拡張子を取得する関数
  getExt(filename)
  {
    var pos = filename.lastIndexOf('.');
    if (pos === -1) return '';
    return filename.slice(pos + 1);
  },



        
    }
}
</script>
